import React, { useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { PanelLayout } from '../../layout/Panel/Panel';
import { AvatarLogo } from '../../shared/AvatarLogo/AvatarLogo';
import { Spacing } from '../../layout/Spacing/Spacing';
import { RelativeCenter } from '../../layout/RelativeCenter/RelativeCenter';
import { Title } from '../../ui/Title';
import { rootState } from '../../../redux/store';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';
import { removeUserAndTokenData } from '../Login/login.slice';
import { useNavigate } from 'react-router-dom';
import { closeUserDisplay } from './userProfile.slice';
import { removeProject } from '../Projects/project.slice';
import { UserProfileDetail } from './UserProfileDetail';
import { UserProfileDetailCard } from './UserProfileDetailCard';
import { ExecButton } from '../../ui/ExecButton/ExecButton';
import { setLogoutFalse, setLogoutTrue } from '../Logout/logout.slice';
import { CloseExec } from '../../ui/CloseButton';
import { removeStagingItem } from '../Dashboard/DashboardStaging/stagingItem.slice';
import { Department } from './Department';
import { clearChildrens } from '../LauncherConfiguration/Features/getAllChildrensPerNode.slice';
import { cleanAvatarType } from '../TreeComposite/TreeSettings/ProjectWindow/avatarType.slice';
import { removeDeletedAvatarId } from '../Dashboard/DashboardStaging/stagingDeletedAvatarsId.slice';
import { removeProjectNode } from '../TreeComposite/TreeWidget/treeNodeSelected.slice';
import { removeStagingId } from '../Dashboard/DashboardStaging/stagingId.slice';
import { useTranslation } from 'react-i18next';
import IconComponent from '../../shared/IconComponents/IconComponent';
import { removeUserSettingsToken } from '../Login/userSettingsSaveUserTokenToDB.slice';
import { removeHostnameAndUsername } from '../WebSocket/websocketHostname.slice';
import { removeAllPaths } from '../UserSettings/FilePath/userSettingsFilePathFastChanging.slice';
import { ProtectedUsers } from '../../shared/ProtectedUsers/ProtectedUsers';
import { PROJECT_ADMIN, Roles } from '../../../constants/constants';
import { closeModal } from '../Modal/modal.slice';
import { Badge } from '../../shared/Badge/Badge';

export const UserProfileInfo = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [timer, setTimer] = useState<number>(1);
    const { t, i18n } = useTranslation();
    const { userAndTokenData } = useAppSelector((state: rootState) => state.loginUserAndTokenData);

    const memoizedUserAndTokenData = useMemo(() => userAndTokenData, [userAndTokenData]);

    const logOut = () => {
        dispatch(setLogoutTrue(timer));
        setTimeout(() => {
            dispatch(removeUserAndTokenData());
            dispatch(removeUserSettingsToken());
            dispatch(closeUserDisplay());
            dispatch(removeProject());
            dispatch(setLogoutFalse());
            dispatch(clearChildrens());
            dispatch(cleanAvatarType());
            dispatch(closeModal("configureModal"));
            dispatch(closeModal("projectModal"));
            dispatch(removeDeletedAvatarId());
            dispatch(removeProjectNode());
            dispatch(removeStagingItem());
            dispatch(removeStagingId());
            dispatch(removeHostnameAndUsername());
            dispatch(removeAllPaths());
            navigate('/');
        }, timer * 1000);
    };

    return (
        <div className="user-profile-container animation-left">
            <PanelLayout>
                <div className="user-display-grid">
                    <CloseExec distanceInPx={10} func={() => dispatch(closeUserDisplay())} />
                    <div className="user-display-grid__header">
                        <Spacing marginSpacing={'none'} paddingSpacing={'l'}>
                            <RelativeCenter>
                                <FlexCenter gap={1.5} direction="h" position="center">
                                    <AvatarLogo size="l" color="accent-blue" userName={userAndTokenData?.user.name || ''} userSurname={userAndTokenData?.user.surname || ''} />
                                    <FlexCenter gap={0.5} direction="h" position="center">
                                        <Title text={`${memoizedUserAndTokenData?.user.name} ${memoizedUserAndTokenData?.user.surname}`} size={'l'}></Title>
                                        <Department />
                                        {/* <HighlightContainer paddingX={.8} paddingY={.2}> */}
                                        {/* </HighlightContainer> */}
                                    </FlexCenter>
                                </FlexCenter>
                            </RelativeCenter>
                        </Spacing>
                    </div>

                    <div className="user-display-grid__main">
                        <Spacing marginSpacing={'none'} paddingSpacing={'l'}>
                            <FlexCenter gap={0.5} direction="h" position="start">
                                <UserProfileDetail>
                                    <ProtectedUsers protectedUsers={PROJECT_ADMIN}>
                                        <UserProfileDetailCard iconName="Admin" label={'User'} text={<Badge label={`${Roles.ADMINISTRATOR}`} color="accent-orange" />} />
                                    </ProtectedUsers>
                                    <UserProfileDetailCard iconName="Email" label={t('info.email')} text={memoizedUserAndTokenData?.user.email || t('info.noInfo')} />
                                    <UserProfileDetailCard iconName="Mobile" label={t('info.mobile')} text={memoizedUserAndTokenData?.user.mobile || t('info.noInfo')} />
                                    <UserProfileDetailCard iconName="Active" label={t('info.active')} text={<IconComponent size={1.6} iconName={'OK'}/>} />
                                    <UserProfileDetailCard iconName="Technical office" label={t('info.technicalOffice')} text={memoizedUserAndTokenData?.user.technicalOffice || t('info.noInfo')} />
                                    <UserProfileDetailCard iconName="Company" label={t('info.company')} text={memoizedUserAndTokenData?.user.company || t('info.noInfo')} />
                                    <UserProfileDetailCard iconName="Country" label={t('info.country')} text={memoizedUserAndTokenData?.user.country || t('info.noInfo')} />
                                    <UserProfileDetailCard iconName="App_version" label={'App version'} text={<p>{process.env.REACT_APP_VERSION || "v1.5"}</p>} />
                                </UserProfileDetail>
                            </FlexCenter>
                        </Spacing>
                    </div>

                    <div className="user-display-grid__footer">
                        <Spacing marginSpacing={'none'} paddingSpacing={'l'}>
                            <ExecButton label={t('buttons.logout')} iconName={'Logout'} func={() => logOut()} />
                        </Spacing>
                    </div>
                </div>
            </PanelLayout>
        </div>
    );
};
